export default "__VITE_ASSET__BBx$4U4T__"